import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
	Button,
	MenuItem,
	Menu,
	ListItemText,
	ListItemIcon,
	Fade
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ArrowRight from "@mui/icons-material/ArrowRightSharp";
import SearchDetail from "@mui/icons-material/ContentPasteSearchTwoTone";

// ViewButtonActions renders the same row menu as ViewButtonSingle for rows that offer more than
// one action. Each action needs a title and an onClick, and may set an icon and a text colour.
export const ViewButtonActions = ({ actions }) => {

	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (e) => {
		setAnchorEl(e.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<Button
				variant="outlined"
				aria-controls="row-actions-menu"
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				onClick={handleClick}
				disableElevation
			>
				<MoreHorizIcon fontSize="small"/>
			</Button>
			<Menu
				id="row-actions-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				TransitionComponent={Fade}
				elevation={5}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
			>
				{actions.map((action) =>
					<MenuItem
						key={action.title}
						onClick={() => {
							handleClose();
							action.onClick();
						}}
					>
						<ListItemIcon>
							{action.icon ?? <SearchDetail/>}
						</ListItemIcon>
						<ListItemText primaryTypographyProps={{ color: action.color }}>
							{action.title}
						</ListItemText>
						<ArrowRight/>
					</MenuItem>
				)}
			</Menu>
		</>
	);

};

export const ViewButtonSingle = ({
	buttonTitle,
	buttonLink,
	buttonProps,
	buttonOnClick
}) => {

	const productID = buttonProps[0]?.id;
	const components = buttonProps[0]?.components;
	const isHidden = buttonProps[0]?.is_hidden;
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (e) => {
		setAnchorEl(e.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<Button
				variant="outlined"
				id="fade-button"
				aria-controls="fade-menu"
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				onClick={handleClick}
				disableElevation
			>
				<MoreHorizIcon fontSize="small"/>
			</Button>
			<Menu
				id="demo-positioned-menu"
				aria-labelledby="demo-positioned-button"
				MenuListProps={{
					"aria-labelledby": "fade-button",
				}}
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				TransitionComponent={Fade}
				elevation={5}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
			>
				<MenuItem
					component={!buttonOnClick ? Link : null}
					to={`${buttonLink}${productID}`}
					onClick={buttonOnClick}
					state={{
						components: components,
						isHidden: isHidden,
					}}
				>
					<ListItemIcon>
						<SearchDetail/>
					</ListItemIcon>
					<ListItemText>
						{buttonTitle}
					</ListItemText>
					<ArrowRight/>
				</MenuItem>
			</Menu>
		</>
	);

};
